import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RegistrerValidationDto } from "@green0meter/api-client";
import { enqueueSnackbar } from "notistack";
import { t } from "i18next";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";

export const ACTION_BLOCK_USER = "BLOCK_USER";

const validateRegistration = async (dto: RegistrerValidationDto): Promise<void> => {
  const response = await usersApi.usersControllerValidateRegistration(dto);

  return response.data;
};

export const useValidateRegistration = (): {
  validateRegistration: (dto: RegistrerValidationDto) => void;
  validateRegistrationAsync: (dto: RegistrerValidationDto) => Promise<void>;
  isSuccessValidateRegistration: boolean;
  isPendingValidateRegistration: boolean;
} => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_BLOCK_USER],
    mutationFn: validateRegistration,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_USERS] });
      enqueueSnackbar(t("register.emailValidationSuccess"), { variant: "success" });
    },
    onError: () => {
      enqueueSnackbar(t("register.emailValidationError"), { variant: "error" });
    },
  });

  return {
    validateRegistration: mutate,
    validateRegistrationAsync: mutateAsync,
    isSuccessValidateRegistration: isSuccess,
    isPendingValidateRegistration: isPending,
  };
};
